import React, { useRef, useEffect, useState } from 'react';
import './AsSeenOnCarousel.css';
import  useFetch  from '../Utils/useFetch';

const LogoCarousel = () => {
  const trackRef = useRef(null);
  const [isUserInteracting, setIsUserInteracting] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [isDragging, setIsDragging] = useState(false);

  const jsonPath = process.env.REACT_APP_CDN_LINK + "myanglai/jsons/asSeenOn.json"
  const imgCDN = process.env.REACT_APP_CDN_LINK + "myanglai/Images/"
  // const data = Content;  
  const logos = useFetch(jsonPath);

  // Mouse events
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setIsUserInteracting(true);
    setStartX(e.pageX - trackRef.current.offsetLeft);
    setScrollLeft(trackRef.current.scrollLeft);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - trackRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    trackRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    setTimeout(() => setIsUserInteracting(false), 2000); // Resume auto-scroll after 2 seconds
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
    setTimeout(() => setIsUserInteracting(false), 2000);
  };

  // Touch events
  const handleTouchStart = (e) => {
    setIsUserInteracting(true);
    setStartX(e.touches[0].pageX - trackRef.current.offsetLeft);
    setScrollLeft(trackRef.current.scrollLeft);
  };

  const handleTouchMove = (e) => {
    const x = e.touches[0].pageX - trackRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    trackRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleTouchEnd = () => {
    setTimeout(() => setIsUserInteracting(false), 2000);
  };

  // Wheel event for desktop scroll
  const handleWheel = (e) => {
    e.preventDefault();
    setIsUserInteracting(true);
    trackRef.current.scrollLeft += e.deltaY;
    setTimeout(() => setIsUserInteracting(false), 2000);
  };

  if (logos === null) {
    return <div />
  }
  return (
    <div className="carousel-container">
      <div className="as-seen-on">
        <span>As Seen On:</span>
      </div>
      <div 
        className={`carousel-wrapper ${isUserInteracting ? 'user-interacting' : ''}`}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseLeave}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onWheel={handleWheel}
      >
        <div className="carousel-track" ref={trackRef}>
          {/* Multiple sets for infinite scroll */}
          {[...Array(4)].map((_, setIndex) => 
           logos && logos.map((logo, index) => (
              <div key={`set-${setIndex}-${index}`} className="logo-item">
                <a href={logo.url} target="_blank" rel="noopener noreferrer" style={{cursor:"pointer"}}>
                <img src={imgCDN + logo.icon} alt={logo.name} draggable={false} />
                </a>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default LogoCarousel;